const adminNotificationTypes = [
  {
    type: 'new-leave-request',
    label: 'New Leave Request',
    description: 'When a labourer submits a leave request'
  },
  {
    type: 'new-support-ticket',
    label: 'New Support Ticket',
    description: 'When a labourer submits a support ticket'
  },
  {
    type: 'open-session-admin-alert',
    label: 'Open Session Alert',
    description: 'When a labourer has a session open for over 12 hours'
  },
  {
    type: 'license-expiry',
    label: 'License Expiry',
    description: "When a labourer's license has expired or is about to expire"
  },
  {
    type: 'document-expiry',
    label: 'Document Expiry',
    description: "When a labourer's document has expired or is about to expire"
  }
];

export default adminNotificationTypes;
